import React from 'react';
import { Activity } from '../../../modules/dialogs/transfer/model';
import { getLogSubtitle } from '../../../modules/dialogs/transfer/utils';
import useLocale from '../../../hooks/useLocale';
import Ellipsis from '../../../components/shared/ellipsis';

interface Props {
  a: Activity;
  isSender: boolean;
}

const LogSubtitle: React.FC<Props> = ({ a, isSender }) => {
  const { translate } = useLocale();
  const msg = getLogSubtitle(a, isSender);
  const translatedMsg = translate(msg);
  return <Ellipsis>{translatedMsg}</Ellipsis>;
};

export default LogSubtitle;
